import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";

import InputGeneric from "../../components/InputGeneric";
import Toggle from "../../components/Toggle";
import {
    INVOICE_PAYMENT_METHOD_OPTIONS,
} from "../../helpers/invoicePaymentMethods";

export type SettingsProps = {
    id: number;
    key: string;
    description: string;
    enabled: number;
    type: string;
    value: string;
    group_id: number;
};

export function SettingConfigInput({
    setting,
    handleChangeInputs,
}: {
    setting: SettingsProps;
    handleChangeInputs: (key: string, value: any) => void;
}) {
    const isNumber = setting.type === "integer" || setting.type === "float";
    const isPaymentMethodsSelect =
        setting.type === "select" || setting.key === "invoice_payment_methods";

    if (setting.type === "boolean") {
        return (
            <Toggle
                className="toggle"
                label={setting.description}
                defaultChecked={Boolean(setting.value)}
                onChange={(event) => {
                    handleChangeInputs(setting.key, event.target.checked);
                }}
            />
        );
    }

    if (isPaymentMethodsSelect) {
        return (
            <div className="inputAndLoadingContainer">
                <FormControl size="small" className="inputs" fullWidth>
                    <InputLabel id={`${setting.key}-label`}>
                        Tipo de pagamento padrão
                    </InputLabel>
                    <Select
                        labelId={`${setting.key}-label`}
                        label="Tipo de pagamento padrão"
                        defaultValue={setting.value || "pix"}
                        onChange={(event: SelectChangeEvent) => {
                            handleChangeInputs(setting.key, event.target.value);
                        }}
                    >
                        {INVOICE_PAYMENT_METHOD_OPTIONS.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                    <p className="setting-helper-text">{setting.description}</p>
                </FormControl>
            </div>
        );
    }

    return (
        <div className="inputAndLoadingContainer">
            <InputGeneric
                className="inputs"
                size="small"
                label={setting.description}
                onChange={(event) => {
                    handleChangeInputs(setting.key, event.target.value);
                }}
                defaultValue={setting.value}
                type={isNumber ? "number" : "text"}
            />
        </div>
    );
}
